import { clickableClass, themeVars } from '@tundr/theme';
import { style } from '@vanilla-extract/css';

export const scrollToTopClass = style({
  position: 'fixed',
  right: 30,
  bottom: 40,
  zIndex: themeVars.zIndex.tooltip,
  backgroundColor: themeVars.colors.neutrals.white,
  borderRadius: themeVars.radius.circle,
  boxShadow: themeVars.shadow.elevationSmall,
  width: 40,
  height: 40,
  display: 'grid',
  placeItems: 'center',
});

export const scrollToTopIconClass = style([
  clickableClass,
  {
    fontSize: themeVars.font.size.iconLg,
    color: themeVars.colors.neutrals.black100,
  },
]);
